import {UINineSlice} from "./UINineSlice";
import {UILabeledIcon} from "./UILabeledIcon";
import {Core} from "../../../Base/Core";

export class UINineSliceButton extends UINineSlice {

    constructor(texture, props = "") {
        super(texture);
        this.cursor = "pointer";
        this.interactive = true;
        this.content = this.addChild(new UILabeledIcon(props));
        this._initialFit();

        this._setTapHighlight = this._setTapHighlight.bind(this);
        this._removeTapHighlight = this._removeTapHighlight.bind(this);

        this.on("pointertap", () => Core.Audio.Play("UIButton"));
        this._initTapHighlight();
    }

    _initialFit() {
        let bounds = this.content.getLocalBounds();
        this.width = bounds.width * 1.1;
        this.height = bounds.height * 1.1;
        this.content.position.set(bounds.width * 0.05, bounds.height * 0.05);
    }

    get label() {
        return this.content._label.text;
    }

    set label(val) {
        this.content._label.text = val || "";
        this.fitLayout();
    }

    get icon() {
        return this.content._icon.texture;
    }

    set icon(val) {
        this.content._icon.setImage(val);
        this.fitLayout();
    }

    _fitChildren() {
        let rect = new PIXI.Rectangle(0, 0, this.width, this.height)
            .pad(-this.width * 0.1, -this.height * 0.1)
        ;
        this.content.fitLayout(rect);
    }

    fitLayout(rect = new PIXI.Rectangle(this.x, this.y, this.width, this.height)) {
        this.position.copyFrom(rect);
        this.width = rect.width;
        this.height = rect.height;
        this._fitChildren();
    }
}
